export const getTimeZoneCity = (timeZone: string) => {
  const city = timeZone.split("/").pop() || timeZone;

  return city.replaceAll("_", " ");
};
